export default __webpack_public_path__ + "70eba4dca9cc4429dbcd5159cf2d1782.png";